import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';

import {
  addOnboardingQuestionnaireAsync,
  onboardingCompletedAsync,
} from './thunks';
import { Server } from '@wajeez/wajeez.microservices';

export const onboardingCompleted = async (
  onSuccess?: () => void | Promise<void>,
  onComplete?: () => void
) => {
  const res = await store.dispatch(onboardingCompletedAsync());

  return handleDispatchResult(res, onSuccess, onComplete);
};

export const OnboardingQuestionnaire = async (
  data: Server.SaveOnboardingQuestionnaireCommand,
  onSuccess?: () => void | Promise<void>
) => {
  console.log({ data });

  const res = await store.dispatch(addOnboardingQuestionnaireAsync(data));

  return handleDispatchResult(res, onSuccess);
};
